import { Injectable, inject } from '@angular/core'
import { ApiClient, ApiClientFactory, serializeHttpParams } from '@ftr/api-shared'
import { CourtRegionResponse, CourtSystem, CourtSystemWithMetadata } from '@ftr/contracts/api/court-system'
import { CourtSystemForUserQuery } from '@ftr/contracts/api/user'
import { ProductFeature } from '@ftr/contracts/type/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'

// GetCourtSystemService was isolated from CourtSystemService to prevent needing to
// provide the entire service to the root scope of the application. Retrieving court
// systems is a requirement of RegionalApiClientFactory
@Injectable({
  providedIn: 'root',
})
export class GetCourtSystemService {
  private readonly courtSystemApiClient: ApiClient

  constructor() {
    const apiClientFactory = inject(ApiClientFactory)
    this.courtSystemApiClient = apiClientFactory.build('/court-system')
  }

  getCourtSystem(courtSystemId: Uuid, includeAddonCounts: boolean = false): ApiResult<CourtSystem> {
    return this.courtSystemApiClient.get({
      params: serializeHttpParams({ includeAddonCounts }),
      path: courtSystemId,
      responseBodyType: CourtSystem,
    })
  }

  getCourtSystemsForUser(params: CourtSystemForUserQuery): ApiResult<CourtSystemWithMetadata[]> {
    return this.courtSystemApiClient.get({ params: serializeHttpParams(params) })
  }

  getCourtSystemProductFeatures(courtSystemId: Uuid): ApiResult<ProductFeature[]> {
    return this.courtSystemApiClient.get({ path: `${courtSystemId}/productFeatures` })
  }

  getRegionForCourtSystemCode(code: string): ApiResult<CourtRegionResponse> {
    return this.courtSystemApiClient.get<CourtRegionResponse>({ path: `${code}/region` })
  }
}
